var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdownbutton"},[_c('ejs-dropdownbutton',_vm._b({on:{"select":_vm.onDropdownButtonSelect}},'ejs-dropdownbutton',_vm.dropdownButtonProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }